import React, { useDeferredValue, useState } from "react";
import { cn } from "@danishagro/shared/src/helpers/classNames.helper";
import { DA_Container } from "@danishagro/shared/src/components/atoms/Container/Container.component";
import { DA_IconNames } from "@danishagro/shared/src/components/atoms/Icon/Icon.component";
import { DA_Input } from "@danishagro/shared/src/components/atoms/Input/Input.component";
import { DA_Title } from "@danishagro/shared/src/components/atoms/Title/Title.component";
import { useTranslations } from "@danishagro/shared/src/contexts/translations/translations.context";
import { useBackgroundColor } from "../../../../hooks/useBackgroundColor/useBackgroundColor.hook";
import { usePadding } from "../../../../hooks/usePadding/usePadding.hook";
import Department from "./components/Department/Department.component";
import { V2Props } from "./DepartmentsListV2.interface";
import { useItems } from "./hooks/useItems.hook";
import S from "./DepartmentsListV2.module.scss";

const V2 = (props: V2Props) => {
    const { backgroundColorClass, hasBackgroundColor } = useBackgroundColor(props.backgroundColor);
    const { paddingClass } = usePadding(props.isCompact, hasBackgroundColor);

    const { getDictionaryString } = useTranslations();

    // Get selected departments
    const selectedDepartment = props.departments?.map((item) => item.id);

    // get All Departments
    const { items, viewState } = useItems(selectedDepartment?.toString());

    const [_searchQuery, setSearchQuery] = useState<string>("");
    const searchQuery = useDeferredValue(_searchQuery);

    const filteredSearch = Array.isArray(items)
        ? items?.filter((x) => {
              const item = x.props;
              const test =
                  `${item?.departmentName}_${item?.address}_${item?.zipCode}_${item?.city}`.toLowerCase();

              if (searchQuery.length > 0) {
                  return test.indexOf(searchQuery.toLowerCase()) >= 0;
              }

              return true;
          })
        : [];

    return (
        <div className={cn(S.wrapper, paddingClass, backgroundColorClass)}>
            <DA_Container noVerticalPadding>
                <div className={S.inner}>
                    <DA_Title h2 noMargin>
                        {getDictionaryString("Department.FindUs")}
                    </DA_Title>
                    <DA_Input
                        icon={DA_IconNames.Zoom}
                        placeholder={getDictionaryString("Department.SearchDepartments")}
                        onChange={setSearchQuery}
                        className={S.search}
                    />

                    {/** Departments */}
                    {viewState === "DONE" ? (
                        <div className={S.listWrapper}>
                            <div className={S.listCount}>
                                {items.length}&nbsp;{getDictionaryString("Department.Departments")}
                            </div>
                            <div className={S.list}>
                                {filteredSearch?.map((item, index) => (
                                    <Department key={index} {...item} />
                                ))}
                            </div>
                        </div>
                    ) : null}
                </div>
            </DA_Container>
        </div>
    );
};

export default V2;
